import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
// import TeamImage from './TeamImage.png'
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {SocialView} from '../SocialView/SocialView'
import {FooterNote} from '../FooterLinks/FooterNote'
import {fetchMenusIfNeeded, selectPressType,
        fetchPressIfNeeded, SERVER_BASE_URL} from '../../actions'

export class PressReleaseView extends React.Component {

  constructor (props) {
    super(props)
    this.renderPressRelease = this.renderPressRelease.bind(this)
    this.renderPageLabel = this.renderPageLabel.bind(this)
  }

  componentWillMount (p) {
    // const {dispatch} = this.props
    // dispatch(selectPressType('pressrelease'))
    const {match, dispatch} = this.props
    //let current_route = this.props.routes[this.props.routes.length-1].path.substr(1)

    let current_route = match.path.substr(1);

    console.log('PRESS: ', this.props);


    if (current_route === 'materiais_apoio') {
      current_route = 'support'
    } else if (current_route === 'comunicados') {
      current_route = 'pressrelease'
    }

    console.log('current_route: ', current_route);

    if(typeof current_route !== 'undefined' && current_route !== '' ) {
      dispatch(selectPressType(current_route))
      dispatch(fetchPressIfNeeded(current_route))
    }

  }

  componentDidMount () {
    const {dispatch, selectedPress} = this.props
    dispatch(fetchMenusIfNeeded(this.props.selectedScope))
  }

  componentWillReceiveProps (nextProps) {
    const {match, dispatch} = nextProps
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope))
    }

    //let current_route = nextProps.routes[nextProps.routes.length-1].path.substr(1)
    let current_route = match.path.substr(1);

    if (current_route === 'materiais_apoio') {
      current_route = 'support'
    } else if (current_route === 'comunicados') {
      current_route = 'pressrelease'
    }

    // console.log('this.props.selectedPress')
    if (this.props.selectedPress !== current_route &&
      typeof current_route !== 'undefined' &&
      current_route !== '') {
      dispatch(selectPressType(current_route))
      dispatch(fetchPressIfNeeded(current_route))
    }
  }

  renderPressRelease () {
    const {press} = this.props
    const num_items = press.length
    return (
      press.map((info, i) => {
        const extraClass = i === (num_items -1) ? 'row' : 'row pressrelease'
        const download_url = `${SERVER_BASE_URL}/api/download_press/${info.id}`
        return (
          <div key={i} className={extraClass}>
            <div className='col-sm-8 col-md-6 col-lg-6'>
              <p className='title' dangerouslySetInnerHTML={{ __html: info.title }}></p>
              <div>
                <a href={download_url}>
                  <button><i className='glyphicon glyphicon-download-alt'></i> DOWNLOAD</button>
                </a>
              </div>
              <p className='desc' dangerouslySetInnerHTML={{ __html: info.description }}></p>
            </div>
          </div>
        )
      })
    )
  }

  renderPageLabel () {
    const {selectedPress} = this.props
    let pretty = 'Comunicados de Imprensa'
    switch (selectedPress) {
      case 'presskit':
        pretty = 'Presskit'
        break
      case 'support':
        pretty = 'Materiais de Apoio'
        break
      default:
        pretty = 'Comunicados de Imprensa'
    }

    return (<p className='left-tag'>{pretty}</p>)
  }

  render () {
    const {menus, press, selectedPress, dispatch} = this.props
    const bottom_menus = menus.bottom || []
    const top_menus = menus.top || []

    if (typeof selectedPress === 'undefined') {
      return
    }

    if (!Object.keys(press).length) {
      return (
        <div>
          <HeaderView top_menus={top_menus} dispatch={dispatch}/>
          <div id='presskit-view' className='team-view'>
            <div className='row'>
              <div className='col-md-12 no-pad text-left'>
                <p className='left-tag'>Comunicados de Imprensa</p>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='presskit-view' className='team-view'>
          <div className='row'>
            <div className='col-md-12 no-pad text-left'>
              {this.renderPageLabel()}
            </div>
          </div>
          <div className='main-block'>
            {this.renderPressRelease()}
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus}/>
        <SocialView customclass='lite'/>
        <FooterNote />
      </div>
    )
  }
}

PressReleaseView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  menus: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  press: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  selectedPress: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired
}

function mapStateToProps (state) {
  const {getMenus, selectedPress, getPress, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  const {
    isFetchingPress,
    items: press
  } = getPress[selectedPress] || {
    isFetchingPress: true,
    items: {}
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingPress,
    press,
    selectedPress,
    selectedScope
  }
}

export default connect(mapStateToProps)(PressReleaseView)



// WEBPACK FOOTER //
// ./src/views/AboutView/PressReleaseView.js